import styled from 'styled-components';
const AnimateCollapse = styled.div `
  overflow: hidden;
  transition: max-height 0.6s ease;
  max-height: ${({ isActive }) => (isActive ? '100vh' : '0')};
`;
export default AnimateCollapse;
//# sourceMappingURL=AnimateCollapse.js.map